/**
 * useMediumListScreen.js
 * ----------------------
 * Hook for Medium list screen using shared useMasterList.
 */
import { useMasterList } from '../../common/useMasterList';
import * as mediumApi from '../api/mediumApi';

export function useMediumListScreen() {
  return useMasterList({
    entityName: 'Medium',
    apiClient: mediumApi.mediumClient,
    fetchList: mediumApi.listMediums,
    archiveItem: mediumApi.archiveMedium,
    deleteItem: mediumApi.deleteMedium,
  });
}
